export const DELETE_RATINGS = 'DELETE_RATINGS';
export const DESCRIPTION = 'DESCRIPTION';
export const RATINGS = 'RATINGS';
export const SUMMARY = 'SUMMARY';
